// components/common/ErrorMessage.jsx
import { FiAlertCircle } from "react-icons/fi";

const ApiErrorMessage = ({ message1, message2 }) => {
  if (!message1) return null;

  return (
    <div className="w-full flex justify-center items-center py-20 px-4 ">
      <div className="bg-orange/5 border border-orange/20 text-orange px-6 py-4 rounded-md text-center max-w-xl w-full shadow-md flex flex-col items-center gap-2">
        <FiAlertCircle className="text-orange w-16 h-16" />
        <p className="text-lg">{message1}</p>
        {message2 && <p className="text-sm font-mono text-orange">{message2}</p>}
      </div>
    </div>
  );
};

export default ApiErrorMessage;
